import { format, parseISO } from 'date-fns'

/**
 * Konwersje między <input type="datetime-local"> a ISO 8601 UTC.
 *
 *  - Input value to lokalny czas bez strefy (np. "2026-05-19T09:00").
 *  - Backend operuje na ISO UTC ("2026-05-19T07:00:00.000Z" dla Warszawy w lecie).
 *  - JS `new Date('YYYY-MM-DDTHH:mm')` interpretuje string jako lokalny czas.
 */

export function toLocalInputFormat(iso: string): string {
  return format(parseISO(iso), "yyyy-MM-dd'T'HH:mm")
}

export function fromLocalInputFormat(local: string): string {
  return new Date(local).toISOString()
}
